import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const AdminRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const isAdmin = user?.email === 'htorres@teiker.mx';

  if (loading) {
    return <div>Cargando...</div>;
  }

  return isAdmin ? <Outlet /> : <Navigate to="/" />;
}; 